import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  toastMessage: {
    minHeight: 48,
    borderRadius: theme.new.shape.borderRadius.medium,
    padding: `${theme.new.shape.borderRadius.medium} ${theme.new.spacing.medium}`,
    border: '1px solid rgba(255, 255, 255, 0.3)',
    backgroundColor: theme.new.color.text.primary,
    color: theme.new.color.common.white,
    display: 'flex',
    alignItems: 'center',
    minWidth: 300,
    maxWidth: 600,
    pointerEvents: 'auto',
    marginBottom: theme.new.spacing.small,
    '& svg': {
      display: 'flex',
      alignItems: 'center',
      width: 16,
      height: 16,
      stroke: `${theme.new.color.common.white} !important`,
    },
  },
  toastIconButton: {
    marginLeft: theme.new.spacing.small,
    '&:focus': {
      outline: `2px solid ${theme.new.color.common.white}`,
      outlineOffset: '2px',
    },
  },
  toastIconError: {
    '& rect': {
      stroke: `${theme.new.color.common.white} !important`,
    },
    '& path': {
      stroke: `${theme.new.color.common.white} !important`,
    },
  },
  toastIconClose: {
    '& path': {
      stroke: `${theme.new.color.common.white} !important`,
    },
  },
}));

export default useStyles;
